export default __webpack_public_path__ + "static/media/ic_document.5067b2cf.svg";